<div>
	<div fxLayout="column" fxFill fxLayoutAlign="flex-end flex-end">
		<button mat-icon-button (click)="onCloseClick()">
			<img
				src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/crossBlack/public"
			/>
		</button>
	</div>
	<div fxLayout="column" fxFill>
		<div ngClass="p-l-l p-r-l">
			<h2 i18n="@@add_offline_donation_heading">Add Offline Donation</h2>
			<span i18n="@@add_offline_donation_amount_collected_subheading"
				>Add amount collected in cash for this fundraiser</span
			>
		</div>
		<mat-dialog-content class="mat-typography">
			<form [formGroup]="this.addOfflineDonationForm">
				<mat-form-field
					color="primary"
					class="w-100"
					appearance="outline"
					floatLabel="always"
				>
					<mat-label i18n="@@fundraiser_createFundraiser_targetAmount_label"
						>Target Amount</mat-label
					>
					<input
						matInput
						type="number"
						formControlName="target_amount"
						class="right-align"
						placeholder="00"
						appNumericInput
						(input)="
							addOfflineDonationForm.controls['target_amount'].markAsTouched()
						"
					/>
					<span matPrefix class="m-l-s">{{ this.currencySymbol }}&nbsp;</span>
					<mat-error
						i18n="@@createFundraiser_decimal_error"
						*ngIf="
							addOfflineDonationForm.controls['target_amount'].errors &&
							addOfflineDonationForm.controls['target_amount'].errors.pattern
						"
					>
						Amount should not contain decimals
					</mat-error>
					<mat-error
						*ngIf="
							addOfflineDonationForm.controls['target_amount'].errors &&
							addOfflineDonationForm.controls['target_amount'].errors.max
						"
					>
						<span i18n="@@custom_donation_form_amountTargetMax_error">
							Maximum required amount is</span
						>&nbsp;{{ currencySymbol }}{{ maxTargetAmount | number }}
					</mat-error>
				</mat-form-field>
				<mat-form-field color="primary" class="w-100" appearance="outline">
					<mat-label i18n="@@describe_the_reason"
						>Describe the reason</mat-label
					>
					<textarea
						required
						matInput
						formControlName="reason"
						cdkTextareaAutosize
						cdkAutosizeMinRows="5"
						cdkAutosizeMaxRows="8"
						id="reason"
						maxlength="70"
						#reason
					></textarea>
					<mat-hint align="end"
						>{{ reason.value.length }} / 70
						<span i18n="@@characters_translation">Characters</span>
					</mat-hint>
					<mat-error
					    i18n="@@offlineDonation_mustBeBetween_error"
						*ngIf="addOfflineDonationForm.controls['reason'].errors"
					>
						Must be between 15 to 70 characters
					</mat-error>
				</mat-form-field>
				<div fxFill fxLayout="row" fxLayoutAlign="end center" ngClass="m-t-l">
					<button
						id="saveBtn"
						i18n="@@button_saveAndContinue"
						mat-flat-button
						(click)="saveOfflineDonation()"
						color="accent"
						[disabled]="!this.addOfflineDonationForm.valid"
					>
						Save
					</button>
				</div>
			</form>
		</mat-dialog-content>
	</div>
</div>
